import { Button } from "@vellum/ui";
import { LinkSection } from "@vellum/vellum-api";

/** The Internal / External toggle shared by the link and folder forms. */
export function SectionPicker({
  value,
  onChange,
}: {
  value: LinkSection;
  onChange: (section: LinkSection) => void;
}) {
  return (
    <div>
      <span className="mb-1 block text-sm font-medium text-gray-700">
        Section
      </span>
      <div className="flex gap-2">
        {Object.values(LinkSection).map((section) => (
          <Button
            key={section}
            type="button"
            variant={value === section ? "primary" : "outline"}
            className={
              value === section
                ? undefined
                : "border-gray-300 text-gray-700 hover:bg-gray-50"
            }
            onClick={() => onChange(section)}
          >
            {section}
          </Button>
        ))}
      </div>
    </div>
  );
}
